import React, { useState, useEffect } from "react";
import HeroSlider from "react-slick";
import carousel from "../../images/carousel.png";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ArrowRightShort, Line } from "react-bootstrap-icons";
import { apiPublishedList } from "../../api/master";
import { Link } from "react-router-dom";
// //Arrows
// import { NextArrow, PrevArrow } from "./Arrows.component";

const HeroCarousel = () => {
  //   const [images, setImages] = useState([]);

  //   useEffect(() => {
  //     const requestNowPlayingMovies = async () => {
  //       const getImages = await axios.get("/movie/now_playing");
  //       setImages(getImages.data.results);
  //     };
  //     requestNowPlayingMovies();
  //   }, []);
  const images = [carousel, carousel, carousel, carousel, carousel];
  const [current, setCurrent] = useState();
  const [currloading, setCurrLoading] = useState(true);
  const [error, setError] = useState(null);

  const settingsLG = {
    arrows: false,
    autoplay: true,
    centerMode: true,
    centerPadding: "300px",
    slidesToShow: 1,
    infinite: true,
    slidesToScroll: 1,
    // nextArrow: <NextArrow />,
    // prevArrow: <PrevArrow />,
  };
  const settings = {
    arrows: false,
    autoplay: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    // nextArrow: <NextArrow />,
    // prevArrow: <PrevArrow />,
  };

  useEffect(() => {
    // console.log("HerCarousel useEffect");
    setCurrLoading(true);
    apiPublishedList({ event_type: 2 })
      .then((res) => {
        // console.log(res.data.data.list);
        setCurrent(res.data.data.list);
        setCurrLoading(false);
        setError(null);
      })
      .catch((err) => {
        // console.log(err);
        setError(err);
      });
  }, []);

  // console.log(current);

  return (
    <>
      <div className="d-block d-sm-none h-50">
        <HeroSlider {...settings}>
          {current &&
            current.map((event) => (
              <div className="px-2 py-3 h-100" style={{ position: "relative" }}>
                <img
                  src={event?.event_banner}
                  alt={`${event?.name} Banner`}
                  className="img-fluid rounded-3"
                  style={{ width: "50em", height: "10em" }}
                />
                <div
                  style={{ position: "absolute", top: "0", width: "9%" }}
                  className="h-100 px-2 py-3 d-flex flex-column justify-content-center gap-1 align-items-start"
                >
                  <h2 className="text-white fw-semibold">{event?.name}</h2>
                  <p className="text-white text-sm">{event?.event_tag_line}</p>
                  <button className="bg-theme-pink text-white border border-0 rounded-2 py-1 px-2 text-xs">
                    <Link to={`/event-details/${event?.event_id}`} style={{ color: "white", outline: "none", textDecoration: "none" }}>
                      Book the Event <ArrowRightShort size={28} />
                    </Link>
                  </button>
                </div>
              </div>
            ))}
        </HeroSlider>
      </div>
      <div className="d-none d-sm-block d-md-none h-50">
        <HeroSlider {...settings}>
          {current &&
            current.map((event) => (
              <div className="px-2 py-3 h-100" style={{ position: "relative" }}>
                <img
                  src={event?.event_banner}
                  alt={`${event?.name} Banner`}
                  className="img-fluid rounded-3"
                  style={{ width: "50em", height: "15em" }}
                />
                <div
                  style={{ position: "absolute", top: "0", width: "9%" }}
                  className="h-100 px-2 py-3 d-flex flex-column justify-content-center gap-2 align-items-start"
                >
                  <h2 className="text-white display-4 fw-semibold">
                    {event?.name}
                  </h2>
                  <p className="text-white">{event?.event_tag_line}</p>
                  <button className="bg-theme-pink text-white border border-0 rounded-2 py-1 px-2">
                    <Link to={`/event-details/${event?.event_id}`} style={{ color: "white", outline: "none", textDecoration: "none" }}>
                      Book the Event <ArrowRightShort size={28} />
                    </Link>
                  </button>
                </div>
              </div>
            ))}
        </HeroSlider>
      </div>
      <div className="d-none d-md-block d-lg-none h-50">
        <HeroSlider {...settings}>
          {current &&
            current.map((event) => (
              <div className="px-2 py-3 h-100" style={{ position: "relative" }}>
                <img
                  src={event?.event_banner}
                  alt={`${event?.name} Banner`}
                  className="img-fluid rounded-3"
                  style={{ width: "55em", height: "22em" }}
                />
                <div
                  style={{ position: "absolute", top: "0", width: "100%" }}
                  className="h-100 px-5 py-3 d-flex flex-column justify-content-center gap-3 align-items-start"
                >
                  <h2 className="text-white display-1 fw-semibold">
                    {event?.name}
                  </h2>
                  <p className="text-white fs-6">{event?.event_tag_line}</p>
                  <button className="bg-theme-pink text-white border border-0 rounded-2 py-2 px-3">
                    <Link to={`/event-details/${event?.event_id}`} style={{ color: "white", outline: "none", textDecoration: "none" }}>
                      Book the Event <ArrowRightShort size={28} />
                    </Link>
                  </button>
                </div>
              </div>
            ))}
        </HeroSlider>
      </div>
      <div className="d-none d-lg-block d-xl-none h-50">
        <HeroSlider {...settingsLG}>
          {current &&
            current.map((event) => (
              <div className="px-2 py-3 h-100" style={{ position: "relative" }}>
                <img
                  src={event?.event_banner}
                  alt={`${event?.name} Banner`}
                  className="img-fluid rounded-3"
                  style={{ width: "100em", height: "15em" }}
                />
                <div
                  style={{ position: "absolute", top: "0", width: "9%" }}
                  className="h-100 px-5 py-3 d-flex flex-column justify-content-center gap-2 align-items-start"
                >
                  <h1 className="text-white fw-semibold">{event?.name}</h1>
                  <p className="text-white text-sm">{event?.event_tag_line}</p>
                  <button className="bg-theme-pink text-white border border-0 rounded-2 py-1 px-2 text-sm">
                    <Link to={`/event-details/${event?.event_id}`} style={{ color: "white", outline: "none", textDecoration: "none" }}>
                      Book the Event <ArrowRightShort size={28} />
                    </Link>

                  </button>
                </div>
              </div>
            ))}
        </HeroSlider>
      </div>
      <div className="d-none d-xl-block d-xxl-none h-50">
        <HeroSlider {...settingsLG}>
          {current &&
            current.map((event) => (
              <div className="px-2 py-3 h-100" style={{ position: "relative" }}>
                <img
                  src={event?.event_banner}
                  alt={`${event?.name} Banner`}
                  className="img-fluid rounded-3"
                  style={{ width: "120em", height: "15em" }}
                />
                <div
                  style={{ position: "absolute", top: "0", width: "10%" }}
                  className="h-100 px-5 py-3 d-flex flex-column justify-content-center gap-2 align-items-start"
                >
                  <h1 className="text-white display-3 fw-semibold">
                    {event?.name}
                  </h1>
                  <p className="text-white">{event?.event_tag_line}</p>
                  <button className="bg-theme-pink text-white border border-1 rounded-2 py-2 px-3">
                    <Link to={`/event-details/${event?.event_id}`} style={{ color: "white", outline: "none", textDecoration: "none" }}>
                      Book the Event <ArrowRightShort size={28} />
                    </Link>
                  </button>
                </div>
              </div>
            ))}
        </HeroSlider>
      </div>
      <div className="d-none d-xxl-block h-50">
        <HeroSlider {...settingsLG}>
          {current &&
            current.map((event) => (
              <div className="px-2 py-3 h-100" style={{ position: "relative" }}>
                <img
                  src={event?.event_banner}
                  alt={`${event?.name} Banner`}
                  className="img-fluid rounded-3"
                  style={{ width: "120em", height: "25em" }}
                />
                <div
                  style={{ position: "absolute", top: "0", width: "8%" }}
                  className="h-100 px-5 py-3 d-flex flex-column justify-content-center gap-4 align-items-start"
                >
                  <h1 className="text-white display-1 fw-semibold">
                    {event?.name}
                  </h1>
                  <p className="text-white fs-5">{event?.event_tag_line}</p>
                  <button className="bg-theme-pink text-white border border-0 rounded-2 py-2 px-3">
                    <Link to={`/event-details/${event?.event_id}`} style={{ color: "white", outline: "none", textDecoration: "none" }}>
                      Book the Event <ArrowRightShort size={28} />
                    </Link>
                  </button>
                </div>
              </div>
            ))}
        </HeroSlider>
      </div>
    </>
  );
};

export default HeroCarousel;
